<template>
  <section class="main">
    <ModuleSection>
      <p>Ihre Auswahlmöglichkeiten:</p>

      <div :class="`grid-${$store.getters.isB2b ? '1' : '2'}_xs-1-spaceBetween-equalHeight u-grid-small-gutter-vertical u-grid-small-gutter-horizontal`">
        <div class="col">
          <FancyChooser
            @click="selectionData.mode = 1; scrollToComposerSection('_ModulePostcardMotive')"
            :isSelected="selectionData.mode === 1"
            @hover="hover"
            :hasGlowingAnimation="selectionData.mode ? false : glowingOptions"
          >
            <template v-slot:title>Mit Grußkarte</template>
            <template
              v-if="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min"
              v-slot:description
            >
              Handgeschrieben oder Gedruckt — Logo-Integration möglich<br /><span><small class='fancy-chooser__description small' v-if="true != isExcluded('PostcardExcludedGroups') && $store.getters.isB2b">+{{ humanPrice($store.getters.getPricesPostcard.default_net) }}</small></span>
            </template>
            <template
              v-else
              v-slot:description
            >
              Handgeschrieben — Vielfältige Motive<br /><span><small class='fancy-chooser__description small' v-if="true != isExcluded('PostcardExcludedGroups') && !$store.getters.isB2b">+ {{ splittedTaxSingle($store.getters.getPricesPostcard.default_net) }} inkl. Mwst</small>
              <small v-else-if="true != isExcluded('PostcardExcludedGroups') && $store.getters.isB2b">+ {{ humanPrice($store.getters.getPricesPostcard.default_net) }}</small></span>
            </template>
            <template v-slot:icon>
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1H30V31H2V1Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.28358 11.505L15.0619 16.25L7.28358 20.9949V11.505ZM7 21.5L15.6064 16.25L7 11V21.5Z" fill="black"/>
                <path d="M23.9297 20.995L16.1513 16.25L23.9297 11.5051V20.995ZM15.6064 16.25L24.2133 21.5V11L15.6064 16.25Z" fill="black"/>
                <path d="M15.6064 16.25L7 21.5V11L15.6064 16.25ZM15.6064 16.25L24.2133 21.5V11L15.6064 16.25ZM7.28358 11.505L15.0619 16.25L7.28358 20.9949V11.505ZM23.9297 20.995L16.1513 16.25L23.9297 11.5051V20.995Z" stroke="black" stroke-width="2" stroke-miterlimit="2" stroke-linejoin="round"/>
              </svg>
            </template>
          </FancyChooser>
        </div>

        <div
          v-if="$store.getters.isB2b"
          class="col"
        >
          <FancyChooser
            @click="selectionData.mode = 2"
            :isSelected="selectionData.mode === 2"
            @hover="hover"
            :isDisabled="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min ? false : true"
            :minQuantity="$store.getters.getOrderQtySize.sm.min"
            :hasGlowingAnimation="selectionData.mode ? false : glowingOptions"
          >
            <template v-slot:title><span>Externe Grußkarte</span><span class="fancy-chooser__description small"><small v-if="true != isExcluded('ExternalPostCard')"><br />+{{ humanPrice($store.getters.getPriceExternalCard.default_net) }}</small></span></template>
            <template v-slot:icon>
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.0001 20L19.7694 18.3266C19.5418 18.1559 19.2818 18.0334 19.0052 17.9666C18.7286 17.8999 18.4413 17.8902 18.1609 17.9383C17.8805 17.9863 17.6128 18.091 17.3742 18.2461C17.1357 18.4011 16.9312 18.6032 16.7734 18.84V18.84C16.5445 19.1835 16.4224 19.5871 16.4224 20C16.4224 20.4128 16.5445 20.8164 16.7734 21.16L18.9668 24.4493C19.6407 25.4596 20.6055 26.2416 21.7334 26.692L25.0001 28V31" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 13L25.8 15.0547C27.2159 15.6619 28.3441 16.7905 28.9507 18.2067L30.5147 21.8667C30.8349 22.6137 31 23.4179 31 24.2307V31" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 19.2493V11L11 16L1 11V21C1 21.5304 1.21071 22.0391 1.58579 22.4142C1.96086 22.7893 2.46957 23 3 23H18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 12V3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H5C4.46957 1 3.96086 1.21071 3.58579 1.58579C3.21071 1.96086 3 2.46957 3 3V12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 5H12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 9H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </template>
          </FancyChooser>
        </div>

        <div class="col">
          <FancyChooser
            @click="selectionData.mode = 3"
            :isSelected="selectionData.mode === 3"
            @hover="hover"
            :hasGlowingAnimation="selectionData.mode ? false : glowingOptions"
          >
            <template v-slot:title><span>Ohne Grußkarte</span><br /><span  class='fancy-chooser__description small'><small>kostenfrei</small></span></template>
            <template v-slot:icon>
              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M4.045 19.955L19.955 4.045" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
            </template>
          </FancyChooser>
        </div>

        <div
          v-if="$store.getters.isB2b"
          class="col"
        >
          <FancyChooser
            @click="selectionData.mode = 4"
            :isSelected="selectionData.mode === 4"
            @hover="hover"
            :isDisabled="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min ? false : true"
            :minQuantity="$store.getters.getOrderQtySize.sm.min"
            :hasGlowingAnimation="selectionData.mode ? false : glowingOptions"
          >
            <template v-slot:title>Später festlegen</template>
            <template v-slot:icon>
              <svg viewBox="0 0 32 32" height="32" width="32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M0.75 14.25L0.75 23.25" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M.75,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M6 18.75L9 18.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M7.684,12.816A8.25,8.25,0,1,1,17.021,17" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M14.25 3.75L14.25 9.75 18 9.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
            </template>
          </FancyChooser>
        </div>
      </div>

      <slot v-if="selectionData.mode == 2">
        <Notice>
          <p>Sie können uns gerne Ihre eigenen Grußkarten postalisch zusenden. Bitte beachten Sie, dass unterschiedliche und / oder personengebundene Grußkarten hierbei nicht möglich sind. Sofern Sie die Präsentboxen persönlich übergeben möchten, können Sie auch die Option "ohne Grußkarte" wählen und Ihre Karten vor Ort beilegen.</p>
        </Notice>
      </slot>

      <slot v-if="selectionData.mode == 4">
        <Notice>
          <p>Sie haben sich noch nicht entschieden? Gerne können Sie die gewünschte Grußkartenoption nach der Bestellung festlegen.</p>
        </Notice>
      </slot>

      <slot v-if="!selectionData.mode">
        <div class="main__onboarding">
          <img
            :srcset="`
              ${require('@/assets/images/postcard-onboarding-example@2x.png')}?format=${webPFormat('png')}&width=1260&quality=80&compression=4 1260w,
              ${require('@/assets/images/postcard-onboarding-example@2x.png')}?format=${webPFormat('png')}&width=630&quality=80&compression=4 630w
            `"
            sizes="
              (max-width: 36em) 90vw,
              36em
            "
            :src="`${require('@/assets/images/postcard-onboarding-example@2x.png')}?format=${webPFormat('png')}&width=630&quality=80&compression=4`"
            alt="Grußkarten Motive Beispiele"
          >
        </div>
      </slot>
    </ModuleSection>
  </section>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';
import { helperMixin } from '@/mixins/HelperMixin';
import { logicMixin } from '@/mixins/LogicMixin';
import ModuleSection from '@/components/Composer/ModuleSection';
import FancyChooser from '@/components/Composer/FancyChooser';
import Notice from '@/components/Composer/Notice';

export default {
  name: 'ModulePostcardMain',
  props: ['selectionData'],
  mixins: [UiMixin, helperMixin, logicMixin],
  components: {
    ModuleSection,
    FancyChooser,
    Notice
  },
  data () {
    return {
      glowingOptions: true
    };
  },
  methods: {
    hover (status) {
      status ? this.glowingOptions = false : this.glowingOptions = true;
    },
    isExcluded(element) {
      if (element === 'PostcardExcludedGroups') {
        return this.$store.getters.getPostcardExcludedGroups.includes(this.$store.getters.getUserGroupId.toString());
      } else if (element === 'ExternalPostCard') {
        return this.$store.getters.getExternalCardExcludedGroups.includes(this.$store.getters.getUserGroupId.toString());
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Postcard Main
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Postcard's main options
 * @since 2021-08-30
**/

$component: 'main';

.#{$component} {
  // background: url('~@/assets/images/stars.svg') center top no-repeat;

  &__onboarding {
    @include margin-bottom(- map-get($spacers, 4));
    @include padding-top(map-get($spacers, 4));
    background: url('~@/assets/images/stars.svg') center top no-repeat;
    pointer-events: none;

    img {
      @include imageRendering;
      display: block;
      width: 130%;
      max-width: unset;
      margin: 0 -15% 0 -15%;
    }
  }

  ::v-deep .fancy-chooser.--has-glowing-animation {
    @include hover () {

    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__onboarding {
      img {
        width: 70%;
        margin: 0 auto;
      }
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__onboarding {
      img {
        width: 80%;
        margin: 0 auto;
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__onboarding {
      background-size: contain;
      background-position: top center;

      img {
        width: 140%;
        margin: 0 -20% 0 -20%;
      }
    }
  }
}
</style>
